import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import {forkJoin, Observable, throwError} from 'rxjs';
import {catchError, map, tap} from 'rxjs/operators';
import { InitialData } from 'app/app.types';
import {environment} from '../environments/environment';
import {UserService} from './core/user/user.service';
import {AuthService} from './core/auth/auth.service';

@Injectable({
    providedIn: 'root'
})
export class InitialDataResolver implements Resolve<any>
{
    /**
     * Constructor
     */
    constructor(
        private _httpClient: HttpClient,
        private _userService: UserService,
        private _authService: AuthService
    ) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Use this resolver to resolve initial mock-api for the application
     *
     * @param route
     * @param state
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<InitialData>
    {
        // Fork join multiple API endpoint calls to wait all of them to finish
        return forkJoin([
            this._httpClient.get<any>(`${environment.node}/navigation`, {reportProgress: true}),
            this._httpClient.get<any>(`${environment.node}/users/me`, {reportProgress: true})
        ]).pipe(
            map(([navigation, user]) => ({
                    navigation: {
                        default: navigation.default,
                        vertical: navigation.vertical,
                        horizontal: navigation.horizontal
                    },
                    user
                })
            ),
            tap((response: InitialData) => {
                this._userService.userNode = response.user;
            }),
            catchError((error) => {
                // Catch "401 Unauthorized" responses
                if ( error instanceof HttpErrorResponse && (error.status === 401 || error.status === 500) )
                {
                    // Sign out
                    this._authService.signOut();

                    // Reload the app
                    location.reload();
                }

                return throwError(error);
            })
        );
    }
}
